import { gql } from "@apollo/client";
import { buildQuery } from "ra-data-graphql-simple";

const customBuildQuery: typeof buildQuery =
  (introspection) => (fetchType, resource, params) => {
    const builtQuery = buildQuery(introspection)(fetchType, resource, params);

    if (
      resource === "ServiceBooking" &&
      (fetchType === "GET_LIST" ||
        fetchType === "GET_MANY" ||
        fetchType === "GET_MANY_REFERENCE")
    ) {
      return {
        // Use the default query variables and parseResponse
        ...builtQuery,
        // Override the query to include fields from referenced service template
        query: gql`
          query allServiceBookings(
            $page: Int
            $perPage: Int
            $sortField: String
            $sortOrder: String
            $filter: ServiceBookingFilter
          ) {
            items: allServiceBookings(
              page: $page
              perPage: $perPage
              sortField: $sortField
              sortOrder: $sortOrder
              filter: $filter
            ) {
              id
              customerId
              customer {
                id
                crmId
                name
                __typename
              }
              domainIds
              amount
              serviceTemplateId
              serviceTemplate {
                id
                name
                monthlyCost
                __typename
              }
              comment
              bookedFrom
              canceledOn
              invoicedUntil
              invoiceInterval
              billingMethod
              createdAt
              updatedAt
              __typename
            }
            total: _allServiceBookingsMeta(
              page: $page
              perPage: $perPage
              filter: $filter
            ) {
              count
              __typename
            }
          }
        `,
      };
    }

    // Custom query to exclude some fields for list views (e.g. dnsZoneId)
    if (
      resource === "Domain" &&
      (fetchType === "GET_LIST" ||
        fetchType === "GET_MANY" ||
        fetchType === "GET_MANY_REFERENCE")
    ) {
      return {
        ...builtQuery,
        query: gql`
          query allDomains(
            $page: Int
            $perPage: Int
            $sortField: String
            $sortOrder: String
            $filter: DomainFilter
          ) {
            items: allDomains(
              page: $page
              perPage: $perPage
              sortField: $sortField
              sortOrder: $sortOrder
              filter: $filter
            ) {
              id
              customerId
              mainDomainId
              isMainDomain
              domain
              unicodeName
              username
              mailEnabled
              managedBy
              serviceBookingId
              aliasDomainCount
              mailAccountCount
              mailForwardCount
              createdAt
              updatedAt
              __typename
            }
            total: _allDomainsMeta(
              page: $page
              perPage: $perPage
              filter: $filter
            ) {
              count
              __typename
            }
          }
        `,
      };
    }

    return builtQuery;
  };
export default customBuildQuery;
